
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.502 2.508c.666-1.153 2.33-1.153 2.996 0l7.488 12.97c.665 1.152-.167 2.593-1.498 2.593H4.512c-1.331 0-2.163-1.44-1.498-2.594l7.488-12.97z"}})])
          )
        }
      }
    